import { render, staticRenderFns } from "./LeftBar.vue?vue&type=template&id=28a974d6&scoped=true&"
import script from "./LeftBar.vue?vue&type=script&lang=js&"
export * from "./LeftBar.vue?vue&type=script&lang=js&"
import style0 from "./LeftBar.vue?vue&type=style&index=0&id=28a974d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a974d6",
  null
  
)

export default component.exports